import { render } from "./FlightSearchComp.vue?vue&type=template&id=4948e45d&scoped=true"
import script from "./FlightSearchComp.vue?vue&type=script&lang=js"
export * from "./FlightSearchComp.vue?vue&type=script&lang=js"

import "./FlightSearchComp.vue?vue&type=style&index=0&id=4948e45d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4948e45d"]])

export default __exports__